module.exports = __webpack_public_path__ + "img/07_sub_uk.7217f918.svg";